import type { Workspace } from "../features/workspaceSlice";

export const transformApiWebsitesToWorkspaces = (data: any[]): Workspace[] =>
  data
    .filter((site: any) => site.is_active === 1)
    .map((site: any) => ({
      id: site.shared_uid,
      name: site.ui_site_name || site.site_name,
      type: "website" as const,
      metadata: {
        site_name: site.site_name,
        site_url: site.site_url,
        ui_site_name: site.ui_site_name,
        dimensions: site.dimensions || [],
      },
    }));

export const hasOrgSummaryPermission = (products: any): boolean => {
  if (!products?.assets || !Array.isArray(products.assets)) return false;
  for (const assetObj of products.assets) {
    const overview = assetObj?.overview;
    if (!Array.isArray(overview)) continue;
    for (const permObj of overview) {
      if (
        permObj &&
        typeof permObj === "object" &&
        "view_organizational_summary" in permObj
      ) {
        return true;
      }
    }
  }
  return false;
};
